// Time and duration rendering shared across the SPA. Every user-facing
// duration goes through here so a lay reader sees "23 min 50 s", never
// "1430.4s" (UAT 2026-09-06). Checklist 36.18 grows this module into the
// one place times are formatted, in the user's own timezone.

/** A duration in seconds as hours, minutes and seconds a person can read. */
export function formatDuration(seconds: number): string {
  if (!Number.isFinite(seconds) || seconds <= 0) return '—';
  const whole = Math.round(seconds);
  const h = Math.floor(whole / 3600);
  const m = Math.floor((whole % 3600) / 60);
  const s = whole % 60;
  const parts: string[] = [];
  if (h > 0) parts.push(`${h} h`);
  if (m > 0) parts.push(`${m} min`);
  if (s > 0 || parts.length === 0) parts.push(`${s} s`);
  return parts.join(' ');
}

/** A moment in Unix seconds as a date in the reader's own timezone and
 *  locale, e.g. "Monday, September 14, 2026". */
export function formatDate(unixSeconds: number): string {
  return new Date(unixSeconds * 1000).toLocaleDateString(undefined, {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}
